import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import CustomerProfileService from '../../../service/CustomerService';
import CustomerModal from './CustomerModal';
import SearchBar from '../../searchbar/SearchBar';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../modules/Constants';

class CustomerProfileView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: [],
      rows: [],
      selectedCustomer: null,
    };

    this.comboFields = [
      {
        value: 'customerId',
        display: 'Customer ID',
      },
      {
        value: 'username',
        display: 'Email Address',
      },
    ];
  }

  onClick(event) {
    this.reset();
    const rows = [];
    const headers = [
      {
        value: 'customerId',
        display: 'Customer ID',
      },
      {
        value: 'locked',
        display: 'Locked',
      },
      {
        value: 'deleted',
        display: 'Deleted',
      },
      {
        value: 'accountType',
        display: 'Account Type',
      },
      {
        value: 'customerType',
        display: 'Customer Type',
      },
      {
        value: 'emailAddress',
        display: 'Email Address',
      },
      {
        value: 'accountId',
        display: 'Account ID',
      },
      {
        value: 'accountUsername',
        display: 'Account Username',
      },
      {
        value: 'timeOfDeletion',
        display: 'Time Of Deletion',
      },
    ];
    const { search, combo, } = event;
    const criteria = {};
    criteria[combo.value] = search.value;

    CustomerProfileService.getCustomers(criteria)
      .then((response) => {
        if (response.data.status === 200) {
          if (typeof response.data.customer !== 'undefined' && response.data.customer) {
            const rawData = response.data.customer;
            // to be backwards compatible, make sure id exists and _id doesn't
            rawData.customer.id = rawData.customer._id;
            delete rawData.customer._id;

            const customer = rawData.customer;
            const account = rawData.account ? rawData.account : '';
            rows.push({
              value: [
                customer?.id || '',
                account?.locked || '',
                customer?.deleted || '',
                account?.accountType || '',
                customer?.customerType || '',
                customer?.emailAddress || '',
                account?._id || '',
                account?.username || '',
                customer.deletionTime ? moment(customer.deletionTime * 1000).utc().format() : '',
              ],
              raw: rawData,
            });
          } else {
            response.data.customers.forEach((customer) => {
              const rawData = customer;
              // to be backwards compatible, make sure id exists and _id doesn't
              rawData.customer.id = rawData.customer._id;
              delete rawData.customer._id;

              const customerObj = rawData.customer;
              const account = rawData.account ? rawData.account : '';
              rows.push({
                value: [
                  customerObj?.id || '',
                  account?.locked || '',
                  customerObj?.deleted || '',
                  account?.accountType || '',
                  customerObj?.customerType || '',
                  customerObj?.emailAddress || '',
                  account?._id || '',
                  account?.username || '',
                  customerObj.deletionTime ? moment(customerObj.deletionTime * 1000).utc().format() : '',
                ],
                raw: rawData,
              });
            });
          }
        }
        this.setState({
          headers,
          rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  onRowSelect(selectedRow) {
    const { rows, } = this.state;
    const selectedCustomer = rows.find((row) => {
      const { raw, } = row;
      return raw.customer.id === selectedRow.customerId;
    });

    this.setState({
      selectedCustomer: selectedCustomer.raw,
    });
  }

  reset() {
    this.setState({
      headers: [],
      rows: [],
      selectedCustomer: null,
    });
  }

  showSelectedDetails(customer) {
    const { sendNavigationRequest, } = this.props;
    if (!customer) {
      return null;
    }
    return (
      <div>
        <p>{`Selected ID: ${customer.customer.id}`}</p>
        <hr />
        <CustomerModal customer={customer} sendNavigationRequest={sendNavigationRequest} />
      </div>
    );
  }

  render() {
    const { headers = [], rows = [], selectedCustomer, } = this.state;
    const style = {
      maxHeight: '500px',
    };

    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={data => this.onClick(data)} />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Customers" style={style}>
            <Grid
              headers={headers}
              rows={rows}
              onRowSelect={row => this.onRowSelect(row)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.showSelectedDetails(selectedCustomer)}
        </div>
      </div>
    );
  }
}

CustomerProfileView.propTypes = {
  sendNavigationRequest: PropTypes.instanceOf(Function).isRequired,
};

export default CustomerProfileView;
